/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as Msdyn365 from '@msdyn365-commerce/core';
import { RichText } from '@msdyn365-commerce/core';
import React from 'react';

export interface IClubPlusBadgeProps {
    displayClubPlusInfo: boolean;
    onToggleClubPlus: () => void;
    priceTooltipText?: RichText;
    clubPlusPrice: string | number | undefined;
    checkUserLoyalty: boolean | undefined;
    checkUserDiscounts: boolean | undefined;
}

const ClubPlusBadge: React.FC<IClubPlusBadgeProps> = ({
    displayClubPlusInfo,
    onToggleClubPlus,
    priceTooltipText,
    clubPlusPrice,
    checkUserLoyalty,
    checkUserDiscounts
}) => {
    if (!checkUserDiscounts) {
        return null;
    }

    // User is a Club Plus member - show simplified badge
    if (checkUserLoyalty) {
        return (
            <div className='product-badge-pdp'>
                <div className='product-card-club-plus-pdp'>
                    <p className='product-club-plus'>
                        Club Plus Price <span className='product-card-club-plus-price-pdp'>£{clubPlusPrice}</span>
                    </p>
                </div>
            </div>
        );
    }

    // User is not a Club Plus member - show badge with info tooltip
    return (
        <div className='product-badge-pdp'>
            <div
                className={displayClubPlusInfo ? 'product-card-club-plus-badge-pdp badge-collapse-pdp' : 'product-card-club-plus-badge-pdp'}
            >
                {displayClubPlusInfo && (
                    <div className='product-club-plus-container-info-pdp'>
                        <div onClick={onToggleClubPlus} className='product-card-club-plus-cross-pdp'></div>
                        <Msdyn365.RichTextComponent className='product-club-plus-info-pdp' text={priceTooltipText} />
                    </div>
                )}
                <div className='product-card-club-plus-pdp'>
                    <p className='product-club-plus'>
                        Club Plus Price <span className='product-card-club-plus-price-pdp'>£{clubPlusPrice}</span>
                    </p>
                    <div
                        onClick={onToggleClubPlus}
                        className={
                            displayClubPlusInfo
                                ? `product-card-club-plus-icon-pdp product-card-club-plus-icon-pdp-close`
                                : `product-card-club-plus-icon-pdp`
                        }
                    >
                        <p>{!displayClubPlusInfo && '?'}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClubPlusBadge;
